import { SegmentHierarchy } from 'src/models/AppContextModels';
import { ForecastTemplateMasterCorpSegmentDropdownValues, OptionDropdown } from 'src/models/ForecastModels';
import { localeCompareNullableSelectProps } from 'src/utils/generic-utilities';

/**
 * Converts segment hierarchy data into sorted dropdown values.
 * Extracts the last element of each hierarchy as the label/value.
 *
 * @param segments - Array of segment hierarchy entries
 * @param corpSegmentName - Display name for the corp segment
 * @returns Dropdown values structure for the segment
 */
export const convertToDropdownValues = (segments: SegmentHierarchy[], corpSegmentName: string): ForecastTemplateMasterCorpSegmentDropdownValues => {
  const dropdownValues: OptionDropdown[] = segments.map((segment) => {
    const lastHierarchyItem = segment.segment_hierarchy[segment.segment_hierarchy.length - 1] || '';
    return {
      label: lastHierarchyItem,
      value: lastHierarchyItem,
      description: segment.segment_description
    };
  });

  dropdownValues.sort((a, b) => localeCompareNullableSelectProps(a, b));

  return {
    masterCorpSegmentDisplayName: corpSegmentName,
    masterCorpSegmentDropdownValues: dropdownValues
  };
};
